import { THandleGetPhoneAgencies } from '../types';

/**
 * @description Get the phone and callerId for the area
 * @param area - The area to get the phone and callerId for
 * @param areas - The areas to search in
 * @returns The phone and callerId for the area
 */

export const handleGetPhoneAgencies = ({
    area,
    areas,
}: THandleGetPhoneAgencies) => {
    if (!area) return { success: false };
    let a = areas.find((item) => item.name === area);
    if (a && a.phone)
        return { success: true, phone: a.phone, callerId: a?.phoneCallerId };
    return { success: false };
};
